var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_-_saved",
    "data-name": "check - saved",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26218",
    "data-name": "Rectangle 26218",
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21068",
    "data-name": "Group 21068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21067",
    "data-name": "Group 21067",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291581",
    "data-name": "Path 291581",
    d: "M12,22.075A10.075,10.075,0,1,1,16.243,2.859.575.575,0,0,1,15.757,3.9,8.841,8.841,0,0,0,12,3.075,8.925,8.925,0,1,0,20.925,12a8.842,8.842,0,0,0-.049-.94.575.575,0,0,1,1.144-.121A10.338,10.338,0,0,1,22.075,12,10.087,10.087,0,0,1,12,22.075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291582",
    "data-name": "Path 291582",
    d: "M12,14.814,8.593,11.406a.575.575,0,0,1,.814-.812L12,13.187l9.093-9.093a.575.575,0,1,1,.814.813Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionCheck);
export default __webpack_public_path__ + "static/media/option_check.34665cddc5fb94de6863d6e6918c7fac.svg";
export { ForwardRef as ReactComponent };